import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\InvoiceExport\BankAccountExportController::__invoke
* @see app/Http/Controllers/InvoiceExport/BankAccountExportController.php
* @route '/api/invoice/export/bank-account'
*/
const BankAccountExportController = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: BankAccountExportController.url(options),
    method: 'post',
})

BankAccountExportController.definition = {
    methods: ["post"],
    url: '/api/invoice/export/bank-account',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\InvoiceExport\BankAccountExportController::__invoke
* @see app/Http/Controllers/InvoiceExport/BankAccountExportController.php
* @route '/api/invoice/export/bank-account'
*/
BankAccountExportController.url = (options?: RouteQueryOptions) => {
    return BankAccountExportController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\InvoiceExport\BankAccountExportController::__invoke
* @see app/Http/Controllers/InvoiceExport/BankAccountExportController.php
* @route '/api/invoice/export/bank-account'
*/
BankAccountExportController.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: BankAccountExportController.url(options),
    method: 'post',
})

export default BankAccountExportController